module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/5/5-e8b30aca320eb583e4fa2bcaff77dc87.jpg";